import {Income} from './income.model';
import {Obligations} from './eligibility-check-request.model';

export class UserDetails {
    public readonly userId: String;
    public readonly name: String;
    public readonly address: String;
    public readonly state: String;
    public readonly postal: String;
    public readonly phoneNumber: String;
    public readonly panNumber: String;
    public readonly dob: Date;

    constructor(userId?: String, name?: String, address?: String, state?: String, postal?: String, phoneNumber?: String,
                panNumber?: String, dob?: Date)
    constructor(userId: String, name: String, address: String, state: String, postal: String, phoneNumber: String,
                panNumber: String, dob: Date) {
        this.userId = userId;
        this.name = name;
        this.address = address;
        this.state = state;
        this.postal = postal;
        this.phoneNumber = phoneNumber;
        this.panNumber = panNumber;
        this.dob = dob;
    }

    public static from(json): UserDetails {
        const userDetails = new UserDetails();
        Object.assign(userDetails, json);
        return userDetails;
    }
}

export class CreditAssessment {
    public readonly userDetails: UserDetails;
    public readonly obligations: Obligations;
    public readonly loanAmount: number;
    public readonly income: Income;
    public readonly applicableTenures: number[];
    public readonly subventionDecimal: number;

    constructor(userDetails?: UserDetails, obligations?: Obligations, income?: Income, loanAmount?: number,
                applicableTenures?: number[], subventionDecimal?: number)
    constructor(userDetails: UserDetails, obligations: Obligations, income: Income, loanAmount: number,
                applicableTenures: number[], subventionDecimal: number) {
        this.userDetails = userDetails;
        this.obligations = obligations;
        this.loanAmount = loanAmount;
        this.income = income;
        this.applicableTenures = applicableTenures;
        this.subventionDecimal = subventionDecimal;
    }

    public static from(json: any) {
        return new CreditAssessment(UserDetails.from(json.userDetails), Obligations.from(json.obligations),
            Income.from(json.income), json.loanAmount, json.applicableTenures, json.subventionDecimal);
    }
}
